var _defs, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f0862836-4e64-470e-8684-783773d4b1d8",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1430 830.83",
    author: "Mahmudul Hasan",
    copyright: "Mahmudul Hasan",
    blogurl: "www.mahmudnotes.com",
    url: "mahmudx.com",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            #leaf,#shroom {\n                animation: bushanim 2s ease infinite;\n                transform-origin: bottom;\n                transform-box: fill-box;\n            }\n\n            @keyframes bushanim {\n                0% {\n                    transform: rotateZ(0deg);\n                }\n\n                50% {\n                    transform: rotateZ(5deg);\n                }\n\n                100% {\n                    transform: rotateZ(0deg);\n                    transform: translateZ(10px);\n                }\n            }\n\n            .cls-1 {\n                fill: #3f3d56;\n            }\n\n            .cls-2 {\n                fill: #ff6584;\n            }\n\n            .cls-3 {\n                opacity: 0.1;\n            }\n\n            .cls-11,\n            .cls-3,\n            .cls-9 {\n                isolation: isolate;\n            }\n\n            .cls-4 {\n                fill: #57b894;\n            }\n\n            .cls-5 {\n                fill: none;\n                stroke: #3f3d56;\n                stroke-miterlimit: 10;\n            }\n\n            .cls-6 {\n                fill: #2f2e41;\n            }\n\n            .cls-7,\n            .cls-9 {\n                fill: #6c63ff;\n            }\n\n            .cls-8 {\n                fill: #fff;\n            }\n\n            .cls-9 {\n                opacity: 0.3;\n            }\n\n            .cls-10 {\n                fill: #ffb9b9;\n            }\n\n            .cls-11 {\n                opacity: 0.2;\n            }\n\n            .cls-12 {\n                fill: #575a89;\n            }\n        "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "404") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Root_Tree",
    "data-name": "Root Tree"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 502.36,
    cy: 821.89,
    rx: 250.3,
    ry: 8.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 385.68,
    cy: 332.89,
    r: 89.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 280.16,
    cy: 791.48,
    rx: 75.49,
    ry: 6.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417.68,822.5s62.65-167.07,28.11-269.88-61.85-98.8-61.85-98.8-46.59-12.05-104.42,23.29-73.09,45.79-106,31.33S134.14,471.49,53.82,473.9c0,0,42.57-23.29,84.33-2.41s69.88,32.13,112.46,0,101.2-73.89,158.23-49c0,0-41.77-41-55.42-41s-77.91-6.42-98.8-28.11c0,0-29.72-20.89-82.73,30.52s-40.16,51.41-87.55,47.39S0,404,0,404s55.42,22.49,89.16,11.25,62.65-53.82,92.37-68.28,47.39-33.73,87.55-12.85c0,0-16.87-69.08-49-63.45s15.26-16.07,15.26-16.07-8.83-117.27-25.7-125.3-6.42-28.92-37.75-32.93c0,0,38.55-4.82,45.78,21.68s57,169.48,57,169.48S305.23,348.6,339,334.14s-12.85-95.58-12.85-95.58l-57.83-26.51s43.37-1.61,69.88,23.29,28.11,105.23,28.11,105.23,66.67,9.64,82.73,45.78c0,0,10.44-32.13-9.64-51.41-5-4.81-10.29-13.2-15.37-23.06-19.44-37.73-26-80.73-19.92-122.72,3-20.55,4.84-40.65,1.56-45.38-7.23-10.44-37.75-74.7-40.16-91.57S367.88,0,367.88,0s.8,43.37,10.44,57,36.95,81.12,36.95,81.12,0,85.15,22.49,126.91,65.86,88.36,63.45,118.88v17.67s48.19-45.78,45-61-7.23-51.41-37.75-73.1-50.6-56.22-28.92-106,21.69-58.64,21.69-58.64l-14.46,61.85s-8,55.42,14.46,74.7S553.42,294,553.42,294L547,178.32l20.88,45.78s45-57.83,98-77.11,86-86.75,86-86.75l45-35.34L759.85,69.08s-11.25,52.21-74.7,89.16S580.73,249.8,578.32,283.54,573.5,347,573.5,347s118.88-4,145.39-56.22,28.91-155.83,54.61-172.7,73.9-37.75,73.9-37.75L793.59,124.5s-11.25,36.14-8.84,61.85-17.67,49.8-17.67,49.8l-15.26,45L735,319.68s69.08,1.61,105.22,42.57,126.11,53,126.11,53l-50.61,13.65s-48.19-16.06-94-45.78-41-56.23-98-26.51-134.94,54.62-134.94,54.62,45-20.88,126.11,29.72-40.16-8.84-76.31,10.44-53-4.82-67.47,43.38-41,179.92-10.44,253.81l30.52,73.9Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M720.1,290.77c-21.53,42.41-104,53-134.23,55.51-.84,10.89-1.4,17.77-1.4,17.77s118.88-4,145.38-56.22S758.77,152,784.47,135.13c2.73-1.79,5.71-3.62,8.86-5.47.88-3.24,1.47-5.16,1.47-5.16l53.82-44.18s-48.19,20.89-73.9,37.75S746.61,238.56,720.1,290.77Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M581.59,209.62c-.18,19.78-2.74,31.54-2.74,31.54s45-57.81,98-77.1c3.13-2,6.31-3.93,9.56-5.82,63.45-36.95,74.7-89.16,74.7-89.16L798,24.9,753,60.24S720.1,127.71,667.09,147C631,160.13,598.56,191.18,581.59,209.62Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M512.18,401v17.67s48.19-45.78,45-61c-2.46-11.68-5.4-35.56-20.29-55.85,6.71,15.34,8.75,30.3,10.54,38.79,2.3,10.94-21.82,37.58-35.66,51.78A36.83,36.83,0,0,1,512.18,401Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M447.53,279.73c.38.82.78,1.62,1.19,2.39C461,305,479.61,329.31,493.5,351.65,482.28,329.53,462.73,304.24,447.53,279.73Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M486.69,245.54c-6.48-15.87-7.54-34.76-.1-56.89a173.36,173.36,0,0,1,1.38-24l12.65-54.1c-2.33,7.8-7.67,22.85-19.88,50.89C465.29,196.94,471.06,224.68,486.69,245.54Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M841.39,362.25c-25.07-28.41-66-37.88-88.68-41l-6.79,15.51s69.07,1.61,105.22,42.57c20,22.72,56.63,36.54,85.26,44.35l31.1-8.39S877.54,403.22,841.39,362.25Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.93,351.2c33.73-14.46-12.85-95.58-12.85-95.58L335.8,255c11.62,24.51,28.46,68.79,4.38,79.11-22.53,9.66-43.63-14.37-55.16-31.39l.65,1.86S316.19,365.66,349.93,351.2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M460,403.41s10.16-31.33-8.93-50.68c4.68,16.67-.82,33.62-.82,33.62-12.43-28-55.13-40.06-73.83-44.1.72,9.31.85,15.38.85,15.38S443.9,367.26,460,403.41Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.64,432.48l.48-.15c33.74-11.25,62.66-53.82,92.38-68.28s47.39-33.73,87.55-12.85c0,0-7-28.76-20.65-47.65a187.45,187.45,0,0,1,10.9,30.59c-40.16-20.88-57.83-1.61-87.55,12.85s-58.64,57-92.37,68.28S1.22,404,1.22,404s37,23.3,84.34,27.31C91,431.79,95.6,432.2,99.64,432.48Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M434.51,822.5c14.72-45.11,50.11-169.87,22.25-252.82-12-35.83-23.19-58.67-32.62-73.24,7.05,13.79,14.76,32,22.87,56.18,34.54,102.81-28.12,269.88-28.12,269.88Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.83,480.36a82.09,82.09,0,0,1,28.29,8.19c33,16.49,57.46,27,87.26,14.81,6.79-3.59,14.39-8,23.14-13.31.69-.5,1.36-1,2.05-1.5,42.57-32.13,101.21-73.9,158.24-49,0,0-11.53-11.3-24.45-22-52.27-12.82-104.62,24.6-143.54,54-42.57,32.13-70.68,20.89-112.45,0S55,473.9,55,473.9C86.07,473,106.07,475.76,120.83,480.36Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.12,252.4a38.75,38.75,0,0,1,3.49,3.76c-3.52-8.46-7.87-15.77-13.23-20.82-26.51-24.9-69.88-23.29-69.88-23.29L323.89,237A77.64,77.64,0,0,1,349.12,252.4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M406.85,143.78c3.27,4.73,1.43,24.83-1.56,45.38-6.11,42,.48,85,19.92,122.72a141.63,141.63,0,0,0,8.56,14.69c-18.51-37.15-24.72-79.24-18.73-120.36,3-20.55,4.83-40.64,1.55-45.37-7.22-10.45-37.75-74.7-40.16-91.57a116.93,116.93,0,0,1-.5-19.71C369.69,31.86,369.09,0,369.09,0s-4.81,35.34-2.4,52.21S399.62,133.34,406.85,143.78Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198.5,113.63c7.08.87,15.22,3,21.43,8.08-.4-1.38-.76-2.6-1-3.64-7.23-26.5-45.78-21.68-45.78-21.68C190.53,98.62,195,106.07,198.5,113.63Z",
    transform: "translate(0 0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shroom"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1384,738.58a11.66,11.66,0,1,0,1.56-22.36l.29,6-2.84-5.14a11.63,11.63,0,0,0-6,6.56,11.8,11.8,0,0,0-.67,3.16A11.67,11.67,0,0,0,1384,738.58Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1398,808.18c-1-5.11,3.34-9.63,7.63-12.57s9.3-5.83,10.77-10.82c2.1-7.17-4.17-13.74-9-19.41a70.07,70.07,0,0,1-9.26-13.75,18.89,18.89,0,0,1-2.21-6.26c-.39-3.18.63-6.34,1.66-9.37q5.15-15.16,11-30.06",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1384.43,737a11.66,11.66,0,1,0,1.56-22.36l.29,6-2.84-5.15a11.65,11.65,0,0,0,1,21.5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1396.58,703.87a11.63,11.63,0,0,1,8.39-7.39l1,5.7,1.78-6a11.66,11.66,0,1,1-11.83,11.48A11.51,11.51,0,0,1,1396.58,703.87Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1397.22,701.81a11.63,11.63,0,0,1,8.39-7.39l1,5.7,1.78-6a11.66,11.66,0,1,1-11.83,11.48A11.51,11.51,0,0,1,1397.22,701.81Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1405.31,765.5a11.66,11.66,0,0,0,10.32-20.74l-1.37,4.6-1-5.77h0a11.66,11.66,0,1,0-8,21.92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1405.87,763.41a11.66,11.66,0,0,0,10.31-20.74l-1.36,4.61-1-5.78h0a11.66,11.66,0,1,0-8,21.92h0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1393.17,784.86a11.65,11.65,0,1,0,2.25-9.13l5.19,7.82-7.09-4.15A11.61,11.61,0,0,0,1393.17,784.86Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1393.65,783.31a11.65,11.65,0,1,0,2.25-9.13l5.19,7.82-7.09-4.15A11.61,11.61,0,0,0,1393.65,783.31Z",
    transform: "translate(0 0)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_404",
    "data-name": 404
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1122.79,
    cy: 811.27,
    rx: 295.49,
    ry: 19.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1111.46,597.11c-48.14,0-82.71,30.89-82.71,103,0,81.68,34.57,103.3,82.71,103.3s84.77-23.68,84.77-103.3C1196.23,615,1159.61,597.11,1111.46,597.11Zm.32,179.15c-33.35,0-50.77-19.56-50.77-76.14,0-49.91,18.14-76.24,51.48-76.24S1164,641.17,1164,700.12C1164,755.27,1145.13,776.26,1111.78,776.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M999.93,746.4H980V687.79a11.74,11.74,0,0,0-11.74-11.74h-4.66a11.73,11.73,0,0,0-11.74,11.74h0V746.4H895.73a6.69,6.69,0,0,1-5.92-9.83L949.23,624.1a11.74,11.74,0,0,0-4.89-15.86l-.48-.24-3.5-1.66A11.75,11.75,0,0,0,925,611.43L852.52,747a15.87,15.87,0,0,0-1.88,7.51h0a15.91,15.91,0,0,0,15.91,15.92h85.33v37.06A14.07,14.07,0,0,0,966,821.56h0A14.07,14.07,0,0,0,980,807.49h0V770.43h19.91a12,12,0,0,0,12-12h0a12,12,0,0,0-12-12Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1368.52,746.4h-19.91V687.79a11.73,11.73,0,0,0-11.74-11.74h-4.66a11.74,11.74,0,0,0-11.74,11.74h0V746.4h-56.15a6.69,6.69,0,0,1-5.92-9.83l59.42-112.47a11.74,11.74,0,0,0-4.89-15.86l-.47-.24-3.51-1.66a11.75,11.75,0,0,0-15.37,5.09L1221.11,747a15.87,15.87,0,0,0-1.88,7.51h0a15.91,15.91,0,0,0,15.91,15.92h85.33v37.06a14.07,14.07,0,0,0,14.07,14.07h0a14.07,14.07,0,0,0,14.07-14.07h0V770.43h19.91a12,12,0,0,0,12-12h0a12,12,0,0,0-12-12Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1005.42,739.54H985.51V680.92a11.74,11.74,0,0,0-11.74-11.74h-4.66a11.74,11.74,0,0,0-11.74,11.74h0v58.62H901.22a6.69,6.69,0,0,1-5.92-9.83l59.42-112.47a11.74,11.74,0,0,0-4.89-15.87l-.47-.23-3.51-1.66a11.74,11.74,0,0,0-15.37,5.08L858,740.14a15.87,15.87,0,0,0-1.88,7.51h0A15.91,15.91,0,0,0,872,763.56h85.33v37.07a14.07,14.07,0,0,0,14.07,14.07h0a14.07,14.07,0,0,0,14.07-14.07h0V763.56h19.91a12,12,0,0,0,12-12h0A12,12,0,0,0,1005.42,739.54Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1378.81,739.54h-19.9V680.92a11.74,11.74,0,0,0-11.74-11.74h-4.67a11.74,11.74,0,0,0-11.73,11.74h0v58.62h-56.15a6.71,6.71,0,0,1-5.93-9.83l59.43-112.47a11.74,11.74,0,0,0-4.9-15.87l-.47-.23-3.51-1.66a11.73,11.73,0,0,0-15.36,5.08L1231.4,740.14a16,16,0,0,0-1.88,7.51h0a15.91,15.91,0,0,0,15.92,15.91h85.33v37.07a14.06,14.06,0,0,0,14.07,14.07h0a14.07,14.07,0,0,0,14.07-14.07h0V763.56h19.9a12,12,0,0,0,12-12h0a12,12,0,0,0-12-12Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1122.45,590.94c-48.15,0-82.71,30.88-82.71,102.95,0,81.68,34.56,103.31,82.71,103.31s84.76-23.68,84.76-103.31C1207.21,608.78,1170.59,590.94,1122.45,590.94Zm.31,179.14c-33.34,0-50.76-19.56-50.76-76.13,0-49.92,18.13-76.24,51.48-76.24S1175,635,1175,694c0,55.14-18.84,76.13-52.19,76.13Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1089.35,
    cy: 682.32,
    rx: 9.52,
    ry: 12.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1141.16,
    cy: 682.6,
    rx: 9.52,
    ry: 12.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1133.88,719c0,5.57-7.77,10.08-17.36,10.08s-17.37-4.51-17.37-10.08c0-4.82,5.83-8.86,13.62-9.84a26.24,26.24,0,0,1,3.75-.24,28.44,28.44,0,0,1,6.23.67C1129.26,711.05,1133.88,714.72,1133.88,719Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1091.59,
    cy: 679.52,
    rx: 9.52,
    ry: 12.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1143.4,
    cy: 679.8,
    rx: 9.52,
    ry: 12.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1118.76,
    cy: 716.21,
    rx: 17.37,
    ry: 10.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1123,710.44a2.8,2.8,0,0,1-.74,1.9,2.42,2.42,0,0,1-1.78.79h-5.6a2.6,2.6,0,0,1-2.52-2.69,2.72,2.72,0,0,1,.45-1.54,26.06,26.06,0,0,1,3.75-.25,26.64,26.64,0,0,1,6.23.71A2.88,2.88,0,0,1,1123,710.44Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1091.59,
    cy: 676.16,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1143.68,
    cy: 676.16,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1146.49,
    cy: 702.49,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1078.14,
    cy: 702.49,
    r: 2.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "shroom",
    "data-name": "shroom"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M825,767a7.66,7.66,0,1,0,1-14.69l.19,3.94-1.86-3.38a7.59,7.59,0,0,0-3.93,4.32,7,7,0,0,0-.44,2.07A7.64,7.64,0,0,0,825,767Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M834.21,812.71c-.66-3.36,2.2-6.33,5-8.26s6.12-3.83,7.08-7.11c1.38-4.71-2.74-9-5.94-12.75a45.88,45.88,0,0,1-6.08-9,12.25,12.25,0,0,1-1.46-4.11,14.16,14.16,0,0,1,1.1-6.16q3.38-10,7.22-19.74",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M825.3,766a7.66,7.66,0,1,0,1-14.69l.19,4-1.87-3.38a7.64,7.64,0,0,0-3.93,4.31,7.81,7.81,0,0,0-.44,2.07A7.65,7.65,0,0,0,825.3,766Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M833.27,744.17a7.65,7.65,0,0,1,5.52-4.85l.63,3.75,1.17-3.94a7.62,7.62,0,1,1-7.32,5Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M833.7,742.82a7.65,7.65,0,0,1,5.51-4.86l.63,3.75,1.17-3.93a7.66,7.66,0,1,1-7.77,7.54A7.37,7.37,0,0,1,833.7,742.82Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M839,784.67A7.66,7.66,0,0,0,845.79,771l-.9,3-.63-3.79h0A7.66,7.66,0,0,0,839,784.66Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M839.38,783.29a7.66,7.66,0,0,0,6.78-13.62l-.9,3-.64-3.79h0a7.66,7.66,0,1,0-5.22,14.4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M831,797.39a7.67,7.67,0,1,0,1.48-6l3.41,5.13-4.66-2.72A7.53,7.53,0,0,0,831,797.39Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M831.35,796.37a7.65,7.65,0,1,0,1.48-6l3.41,5.14-4.66-2.73A7.66,7.66,0,0,0,831.35,796.37Z",
    transform: "translate(0 0)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "leaf",
    className: "cls-1",
    d: "M398.14,788.18c5.72,21.17,25.34,34.28,25.34,34.28s10.33-21.21,4.6-42.38-25.34-34.28-25.34-34.28S392.41,767,398.14,788.18Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "leaf",
    "data-name": "leaf",
    className: "cls-7",
    d: "M406.55,783.63c15.72,15.3,17.64,38.82,17.64,38.82s-23.56-1.29-39.28-16.59-17.63-38.81-17.63-38.81S390.84,768.33,406.55,783.63Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "leaf",
    "data-name": "leaf",
    className: "cls-7",
    d: "M354.47,209.64c-1.37,21.89-18,38.67-18,38.67s-14.37-18.71-13-40.6,18-38.67,18-38.67S355.83,187.75,354.47,209.64Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "leaf",
    "data-name": "leaf",
    className: "cls-7",
    d: "M181.54,71.26c18.55,11.7,25.32,34.3,25.32,34.3s-23.31,3.64-41.86-8-25.32-34.3-25.32-34.3S163,59.57,181.54,71.26Z",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "leaf",
    "data-name": "leaf",
    className: "cls-7",
    d: "M140.11,338.12c18.55,11.69,25.32,34.3,25.32,34.3s-23.31,3.64-41.86-8.06-25.32-34.3-25.32-34.3S121.56,326.42,140.11,338.12Z",
    transform: "translate(0 0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "leaf",
    "data-name": "leaf",
    className: "cls-7",
    d: "M238.81,440.47c18.55,11.7,25.32,34.3,25.32,34.3s-23.31,3.64-41.86-8S197,432.42,197,432.42,220.26,428.78,238.81,440.47Z",
    transform: "translate(0 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "leaf",
    "data-name": "leaf",
    className: "cls-7",
    d: "M517.26,110.28c-5.59,21.2-25.12,34.44-25.12,34.44s-10.47-21.15-4.87-42.36S512.4,67.92,512.4,67.92,522.86,89.07,517.26,110.28Z",
    transform: "translate(0 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "leaf",
    "data-name": "leaf",
    className: "cls-7",
    d: "M693.75,126.81C687.17,147.73,667,160,667,160s-9.46-21.61-2.89-42.53,26.71-33.23,26.71-33.23S700.32,105.89,693.75,126.81Z",
    transform: "translate(0 0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "leaf",
    "data-name": "leaf",
    className: "cls-7",
    d: "M884.5,359.66c-11.91,18.42-34.59,24.92-34.59,24.92s-3.37-23.35,8.54-41.77S893,317.9,893,317.9,896.41,341.25,884.5,359.66Z",
    transform: "translate(0 0)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "man"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M585,510.24s-1.92,7,1.91,9.57,5.1,14.66,5.1,14.66l-7.65,21L564,559.35l-7.65-14.67V523s2.55-10.84,1.91-14S585,510.24,585,510.24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M585,510.24s-1.92,7,1.91,9.57,5.1,14.66,5.1,14.66l-7.65,21L564,559.35l-7.65-14.67V523s2.55-10.84,1.91-14S585,510.24,585,510.24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M605.44,630.78,622,634s1.27,18.49,0,23-2.56,9.56-1.28,10.84-5.74,33.8-5.1,35.71,1.91,7.66,1.27,11.48-2.55,2.55-1.27,6.38,2.55,4.47,1.27,7-7.65,64.41-9.56,65-19.14,1.28-19.14,0S594,782.57,592.05,780s.64-45.92.64-47.84,3.83-5.1,1.91-6.37-3.19-2.56-2.55-4.47,1.91-2.55.64-4.46-1.28-40.18-5.74-41.46c0,0-5.74,28.06-3.83,35.08s-.64,9.57-.64,9.57l8.93,7.65-12.11,23L566.54,736s0-3.83-2.55-4.46-3.83-1.28-3.83-3.19-4.46-14-4.46-14-12.76-40.18-6.38-60.59S558.15,634,558.15,634Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "615.65 762.8 622.66 770.45 620.11 791.5 614.37 791.5 605.44 771.73 615.65 762.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620.11,776.83s-2.55,5.74-4.46,4.46-2.55-3.19-5.42-3.19-5.42.64-4.79,1.92,8.29,15.3,8.29,15.3a18,18,0,0,1,0,15.31c-3.82,8.29,10.21,12.75,12.76,3.83s3.19-19.14,2.55-23,3.19-23.6,3.19-23.6-10.3-4.75-13.44-4.93C618.79,763,621.39,774.28,620.11,776.83Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M602.89,790.86l2.55,7.65s0,7.66,2.56,11.48,5.1,12.12-5.11,12.76-14.67-3.19-14.67-3.19,1.92-5.1,0-7,0-5.74,0-5.74l1.92-15.3Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585.67,727.08h5.74l28.7,37.63s-5.1,12.12-12.75,13.39c0,0-1.28-.63-7-4.46s-21-23-21-23l-1.92-10.84Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 571.64,
    cy: 498.12,
    r: 20.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M596.52,524.27l-6.38-2.55S589.5,544,577.38,544s-24.87-3.19-24.87-9.57S542.3,546,542.3,546s9.57,63.78,8.93,64.42,7,34.44,7,34.44,32.53,1.27,43.37-3.19,14-12.76,14-12.76l-4.47-56.12-8.92-43.37Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M585.68,518.53s2.54-2.55,6.37,0,27.42,8.29,27.42,10.2V553s.64,3.83-1.27,6.38-6.38,12.12-3.83,16.58,12.12,56.12,10.21,62.5-7,12.12-7,12.12-27.42-58-27.42-74.62.26-36.93.26-36.93Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M613.73,529.37h5.74s21.69,41.46,21.69,49.75-14,54.21-15.31,54.85-5.1-7-5.1-7l-3.19-25.51s6.38-15.31,4.47-17.86-11.48-22.32-11.48-22.32Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M557.28,518.53s-7.32,5.1-8.6,7-20.41,12.75-21,15.3,14.66,24.24,14.66,24.24,6.38,35.71,6.38,38.26,2.55,45.92,2.55,45.92,26.15,7.66,26.15,3.19.64-68.24-3.19-82.27S557.28,518.53,557.28,518.53Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M561.44,650.55s21.68,29.34,10.2,28.7-19.13-25.51-19.13-25.51Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M535.29,538.94l-7.65,1.91s-6.38,56.13-2.56,63.78,24.24,57.4,24.24,55.49,17.95-5.33,17.27-7.13-4.51-9.46-5.79-12-3.19-5.74-2.55-8.93-7-16.83-7-16.83-1.91-8-2.55-11.87-6.38-45.92-6.38-45.92Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M591.65,482.32a5,5,0,0,0-2.31-2.83,10.81,10.81,0,0,0-.48-3.75c-1.28-3.53-4.28-3.33-7.12-4.89-1.24-.68-1.16-1.28-1.8-2.4a9.2,9.2,0,0,0-3.63-3.48,13.56,13.56,0,0,0-5.9-2.36c-4.53-.29-8,3.72-12.33,5-1.91.56-4,.59-5.88,1.12s-3.83,1.82-4.12,3.68c-.13.86.1,1.75,0,2.61-.27,1.71-1.86,2.9-2.93,4.31-2.36,3.11-2.09,7.5-.2,10.89a15,15,0,0,0,1.36,2,11.75,11.75,0,0,0,1.44,4.58c1.88,3.38,5.13,5.91,8.52,8a17.87,17.87,0,0,1-.5-3.41,2.22,2.22,0,0,1,.15-1.14c.38-.74,1.38-.94,2.14-1.34a5,5,0,0,0,2.24-4.42c0-1.7-.34-3.41-.15-5.11a2.7,2.7,0,0,1,1-2,3.53,3.53,0,0,1,1.91-.43c3.23-.13,6.6-.18,9.45-1.62a14,14,0,0,1,3-1.4c2.42-.6,4.89,1,6.29,3s2.09,4.28,3.37,6.29,3.51,3.82,6,3.59a1,1,0,0,0,.75-.32,1,1,0,0,0,.13-.59l.14-9A12.74,12.74,0,0,0,591.65,482.32Z",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.5ae343be959e00dc41f6d459d76e828e.svg";
export { ForwardRef as ReactComponent };